import { Stack, TableContainer } from "@mui/material";
import MuiTable from "@mui/material/Table";
import EmptyList from "components/EmptyList";
import ListPagination from "components/ListPagination";
import { ILimit } from "hooks/useList";
import { IdentifiableWithCalculatedParams, TableViewProps } from "../../types";
import TableBody from "./components/TableBody";
import TableHeader from "./components/TableHeader";

const TableView = <
  T extends IdentifiableWithCalculatedParams,
  AvailableFilters extends object,
  OrderField extends string,
  CollapsingRowName extends string | undefined = undefined,
>(
  props: TableViewProps<T, CollapsingRowName>
) => {
  const {
    data,
    totalCount,
    emptyPlaceholderText,
    collapsingRowName,
    onRowClick,
    getRowBackgroundColor,
    getRowOpacity,
    selectedProps,
  } = props;

  const LIMITS: ILimit[] = [
    { label: "50", value: "50" },
    { label: "100", value: "100" },
    { label: "150", value: "150" },
    { label: "Все", value: "100000" },
  ];

  if (!data.length) return <EmptyList emptyPlaceholderText={emptyPlaceholderText} />;
  return (
    <Stack spacing={3}>
      <TableContainer sx={{ overflowX: "auto", "& .MuiTable-root": { borderCollapse: "separate" } }}>
        <MuiTable>
          <TableHeader<T, AvailableFilters, OrderField>
            collapsingRowName={collapsingRowName}
            data={data}
            selectedProps={selectedProps}
          />
          <TableBody<T, CollapsingRowName>
            data={data}
            collapsingRowName={collapsingRowName}
            onRowClick={onRowClick}
            getRowBackgroundColor={getRowBackgroundColor}
            getRowOpacity={getRowOpacity}
            selectedProps={selectedProps}
          />
        </MuiTable>
      </TableContainer>
      <ListPagination
        text={"Количество\nна странице"}
        totalCount={totalCount || 0}
        limits={LIMITS}
        defaultLimit={50}
      />
    </Stack>
  );
};

export default TableView;
